module.exports = __webpack_public_path__ + "img/image55.f4c76730.png";